// Objection to Google Ads measurement without consent (Art. 21 GDPR).
// The custom pixel "Google Ads Consent Mode Schatten-Pixel" reads the same cookie and stays
// silent while it is set, so the cookie name and value must match the pixel code.
if (!customElements.get('measurement-optout')) {
  customElements.define('measurement-optout', class extends HTMLElement {
    static cookieName = 'sps_ads_optout';
    static maxAge = 60 * 60 * 24 * 365 * 2;

    connectedCallback() {
      this.optoutButton = this.querySelector('[data-action="optout"]');
      this.optinButton = this.querySelector('[data-action="optin"]');
      this.onOptout ||= () => this.write(true);
      this.onOptin ||= () => this.write(false);
      this.optoutButton?.addEventListener('click', this.onOptout);
      this.optinButton?.addEventListener('click', this.onOptin);
      this.render();
    }

    disconnectedCallback() {
      this.optoutButton?.removeEventListener('click', this.onOptout);
      this.optinButton?.removeEventListener('click', this.onOptin);
    }

    get optedOut() {
      const name = this.constructor.cookieName;
      return document.cookie.split(';').some((part) => part.trim() === `${name}=1`);
    }

    write(optOut) {
      const { cookieName, maxAge } = this.constructor;
      const secure = location.protocol === 'https:' ? '; secure' : '';
      document.cookie = optOut
        ? `${cookieName}=1; max-age=${maxAge}; path=/; samesite=lax${secure}`
        : `${cookieName}=; max-age=0; path=/; samesite=lax${secure}`;
      this.render();
      (optOut ? this.optinButton : this.optoutButton)?.focus({ preventScroll: true });
    }

    render() {
      const optedOut = this.optedOut;
      this.dataset.state = optedOut ? 'optedout' : 'active';
      this.querySelectorAll('[data-when]').forEach((node) => {
        node.hidden = node.dataset.when !== this.dataset.state;
      });
      if (this.optoutButton) this.optoutButton.hidden = optedOut;
      if (this.optinButton) this.optinButton.hidden = !optedOut;
      this.hidden = false;
    }
  });
}
